import { GraviButton, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Card } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { useUserSettings } from '@hooks/settings'
import { useSecurityContext } from '@/components/Navigation/SecurityContext'

interface OrderAttachmentsProps {
  orderNumber: string | number
}

export function OrderAttachments({ orderNumber }: OrderAttachmentsProps) {
  const { updateSetting } = useUserSettings()
  const { scopes } = useSecurityContext()

  if (!scopes.scopes?.includes('om.p')) return null

  return (
    <Card size='small' style={{ flex: 1 }}>
      <Vertical gap={8}>
        <Texto appearance='hint'>Order Attachments</Texto>

        <Link
          target='_blank'
          to={`/order_movements_page/report?${new URLSearchParams({ order_number: orderNumber.toString() })}`}
          onClick={() => {
            localStorage.setItem('current-order-movements-report-view', 'all')
            updateSetting('current-order-movements-report-view', 'all')
          }}
        >
          <GraviButton
            appearance='filled'
            size='small'
            icon={<MaterialIcon style={{ verticalAlign: 'middle' }} icon='outgoing_mail' size={16} />}
            buttonText='View Order Movements'
          />
        </Link>
      </Vertical>
    </Card>
  )
}
